import { NavigateFunction, Params, useNavigate, useParams } from 'react-router';

export const useTypedParams: <T = string | number>(paramName: string, type: 'string' | 'number') => T | null = <T = string | number>(
  paramName: string, type: 'string' | 'number'
): T | null => {
  const params: Params = useParams();
  const navigate: NavigateFunction = useNavigate();

  if (type === 'number') {
    const paramValue: number = Number(params[paramName]);
    if (!isNaN(paramValue)) {
      return paramValue as T;
    }
  } else if (type === 'string') {
    const paramValue: string | undefined = params[paramName];
    if (paramValue?.length) {
      return paramValue as T;
    }
  }

  navigate('/404');

  return null;
};
